module.exports = __webpack_public_path__ + "img/profile_sp.c12f6861.png";